export const css = {
	root: '_2dMKX5RB',
	tabTitle: '_2AVYZSl9',
	title: 'Ni0oEtHG',
	titleClosed: '_3-OzYHJX',
	titleOpen: '_3b5nFq9R',
	bookIcon: '_3xKzEB82',
	lockIcon: 'X5S3PFdI',
	' _key': 'certwise-theme/certwise/explore-view/content-order'
};

export default css;
